import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../_services/auth.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Le chiamate PVGIS devono uscire "pulite" da header applicativi.
  if (req.url.startsWith('/pvgis')) {
    return next(req);
  }

  // se l’URL comincia con uno dei domini esclusi -> bypass
  const isExcluded = environment.excludedDomains.some((domain) =>
    req.url.startsWith(domain),
  );

  if (isExcluded) {
    return next(req);
  }

  const auth = inject(AuthService);
  const isAuthEndpoint = /\/auth\/(login|refresh|logout)/.test(req.url);
  const isAnonymousRoleRequest =
    req.headers.get('x-hasura-role')?.toLowerCase() === 'anonymous';
  const token = auth.getAccessToken();
  const authId = auth.getDecodedToken()?.sub;

  const buildRequest = (request: typeof req, accessToken?: string) => {
    let headers = request.headers;

    if (isAnonymousRoleRequest && authId) {
      headers = headers.set('x-hasura-user-id', authId);
    }

    if (accessToken && !isAnonymousRoleRequest) {
      headers = headers.set('Authorization', `Bearer ${accessToken}`);
    }

    return headers === request.headers ? request : request.clone({ headers });
  };

  const cloned = buildRequest(req, token ?? undefined);

  return next(cloned).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || isAuthEndpoint) {
        return throwError(() => error);
      }

      return auth.refresh().pipe(
        switchMap((success) => {
          if (!success) {
            return throwError(() => error);
          }

          const newToken = auth.getAccessToken();
          if (!newToken && !isAnonymousRoleRequest) {
            return throwError(() => error);
          }

          const retried = buildRequest(req, newToken ?? undefined);

          return next(retried);
        }),
      );
    }),
  );
};
